export default __webpack_public_path__ + "static/chinese-bird-and-flower-art-86e1cb4db90e733b29c2804515f3e62a.png";